// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .margin[data-v-70c3c7f0] {\n  margin-top: 60px;\n}\n.save-button[data-v-70c3c7f0] {\n  font-size: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
